import { normalizeStateFips } from './utilityData';

const UNSUPPORTED_UTILITY_STATE_FIPS = new Set(['09', '11']);

export const canUseUtilityView = ({ isAuthenticated, predictionType, stateId, userTier }) => {
  if (
    !isAuthenticated
    || userTier !== 'pro'
    || predictionType !== 'daily'
    || !stateId
    || String(stateId).toUpperCase() === 'US'
  ) {
    return false;
  }

  try {
    // Utility seed data currently has no reviewed Connecticut or D.C. mappings.
    return !UNSUPPORTED_UTILITY_STATE_FIPS.has(normalizeStateFips(stateId));
  } catch {
    return false;
  }
};

export const buildUtilityRecords = ({
  companies,
  predictions,
  selectedDay,
  metric
}) => companies.map((company) => {
  const entries = predictions[company.id] || [];
  const entry = entries.find((candidate) => candidate.date === selectedDay);
  const hasPrediction = Boolean(entry);
  const value = hasPrediction ? Number(entry?.customers?.[metric] || 0) : 0;

  return {
    ...company,
    hasPrediction,
    value,
    percentOut: company.customers > 0 ? (value / company.customers) * 100 : 0,
    date: selectedDay
  };
});

export const rankUtilityRecords = (records) => [...records].sort((left, right) => (
  right.value - left.value || String(left.id).localeCompare(String(right.id), undefined, { numeric: true })
));

export const summarizeUtilityRecords = (records, selectedDay) => {
  const recordsWithPrediction = records.filter((record) => record.hasPrediction);
  const customersOut = recordsWithPrediction.reduce((total, record) => total + record.value, 0);
  const customersServed = recordsWithPrediction.reduce((total, record) => total + record.customers, 0);

  return {
    value: customersOut,
    percentOut: customersServed > 0 ? (customersOut / customersServed) * 100 : 0,
    date: selectedDay
  };
};

const getLayerBoundsArea = (layer) => {
  const bounds = layer.getBounds?.();
  if (!bounds?.isValid()) return 0;

  const northWest = bounds.getNorthWest();
  return (
    northWest.distanceTo(bounds.getNorthEast())
    * northWest.distanceTo(bounds.getSouthWest())
  );
};

export const stackSmallTerritoriesOnTop = (layers) => {
  [...layers]
    .sort((left, right) => getLayerBoundsArea(right) - getLayerBoundsArea(left))
    .forEach((layer) => layer.bringToFront());
};
